<template>
  <el-container class="main-container">
    <div class="content-wrapper">
      <!-- 顶部图片 -->
      <section>
        <div class="top-banner-container">
          <img src="/static/ad2.jpg" class="top-banner">
        </div>
      </section>

      <!-- 新闻列表部分 -->
      <section class="news-section">
        <div class="news-container">
          <el-row
              v-for="(group, rowIndex) in groupedList"
              :key="rowIndex"
              class="news-row"
              :gutter="30"
          >
            <el-col
                v-for="(item, index) in group"
                :key="index"
                :span="12"
                class="news-col"
            >
              <router-link :to="{ name: 'NewsInfo', params: { id: item.id } }" class="news-link">
                <div class="news-item">
                  <div class="news-content">
                    <div class="news-title">{{ item.title }}</div>
                    <div class="news-time">{{ item.createTime }}</div>
                  </div>
                  <div class="news-image">
                    <img :src="item.picUrl" class="news-img" />
                  </div>
                </div>
              </router-link>
            </el-col>
          </el-row>
        </div>

        <!-- 分页 -->
        <el-pagination
            class="news-pagination"
            background
            layout="prev, pager, next"
            :limit.sync="pageSize"
            :page.sync="currentPage"
            :total="total"
            @current-change="handlePageChange"
        />
      </section>
    </div>
  </el-container>
</template>

<script>
import {listNews} from "@/utils/http";

export default {
  name: "App",
  props: ['t', 'currentLang'],
  computed: {
    groupedList() {
      const result = []
      for (let i = 0; i < this.newList.length; i += 2) {
        result.push(this.newList.slice(i, i + 2))
      }
      return result
    }
  },
  data() {
    return {
      flagCn: 'https://flagcdn.com/w40/cn.png',
      flagEn: 'https://flagcdn.com/w40/gb.png',
      params:{
        eType:0
      },
      newList:[],
      total:0,
      currentPage: 1,
      pageSize: 10,
    };
  },
  created() {
    this.initNewList();
  },
  watch: {
    currentLang(newVal, oldVal) {
      this.onLangChange(newVal);
    }
  },
  methods: {
    onLangChange(lang) {
      if(lang==='zh'){
        this.params.eType=0;
      }else{
        this.params.eType=1;
      }
      this.initNewList();
    },
    initNewList() {
      const queryParams = {
        ...this.params,
        pageNum: this.currentPage,
        pageSize: this.pageSize
      };
      listNews(queryParams).then(response => {
        this.newList = response.rows;
        this.total = response.total;
      }).catch(error => {
        console.error('获取新闻列表失败:', error);
      });
    },
    handlePageChange(page) {
      this.currentPage = page;
      this.initNewList();
    }
  }
};
</script>

<style scoped>
/* 基础样式 */
section, div, img {
  margin: 0;
  padding: 0;
}

img {
  display: block;
  max-width: 100%;
}

.el-menu--horizontal > .el-menu-item.is-active {
  border-bottom: none !important;
}

.el-menu--horizontal > .el-menu-item:hover {
  border-bottom: none !important;
}

.main-container {
  width: 100%;
  max-width: 100%;
  margin: 0 auto;
}

.content-wrapper {
  width: 100%;
  max-width: 1920px;
  margin: 0 auto;
}

.top-banner-container {
  width: 100%;
  max-width: 1920px;
  margin: 0 auto;
  overflow: hidden;
}

.top-banner {
  width: 100%;
  height: auto;
}

.news-section {
  background-color: white;
  height: auto;
  min-height: 1194px;
  margin: 0 auto;
  padding: 0;
  width: 100%;
  max-width: 1920px;
}

.news-container {
  width: 1140px;
  margin: 0 auto;
  padding: 40px 0;
}

.news-row {
  padding-top: 30px;
  display: flex;
  justify-content: flex-start;
}

.news-col {
  margin-bottom: 30px;
}

.news-link {
  color: inherit;
  text-decoration: none;
  display: block;
}

.news-item {
  display: flex;
  height: 148px;
  background-color: #000;
  color: white;
}

.news-content {
  width: 300px;
  padding: 10px 0 10px 20px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}

.news-title {
  width: 261px;
  height: 105px;
  overflow: hidden;
  line-height: 1.4;
}

.news-time {
  width: 260px;
}

.news-image {
  border: 1px solid #000;
}

.news-img {
  width: 256px;
  height: 146px;
  display: block;
}

.news-pagination {
  margin-top: 30px;
  text-align: center;
}

.news-link:hover .news-item {
  opacity: 0.9;
  transform: translateY(-2px);
  transition: all 0.3s ease;
}

/* 高分辨率适配 */
@media screen and (min-width: 1921px) {
  .top-banner {
    width: 1920px;
    margin: 0 auto;
    display: block;
  }
}

/* 纯移动端样式 - 只在小于768px时生效 */
@media screen and (max-width: 768px) {
  .news-section {
    height: auto;
    padding-bottom: 30px;
    min-height: auto;
  }

  .news-container {
    width: 100%;
    margin-top:-50px;
  }

  .news-row {
    flex-direction: column;
    padding-top: 15px;
  }

  .news-col {
    width: 100% !important;
    margin-bottom: 15px;
  }

  .news-item {
    flex-direction: column;
    height: auto;
  }

  .news-content {
    width: 100%;
    padding: 15px;
  }

  .news-title {
    width: 100%;
    height: auto;
    margin-bottom: 10px;
  }

  .news-time {
    width: 100%;
  }

  .news-image {
    width: 100%;
    border: none;
    border-top: 1px solid #333;
  }

  .news-img {
    width: 100%;
    height: auto;
  }

  .news-pagination {
    margin-top: 20px;
  }
}

/* 小屏幕手机调整 */
@media screen and (max-width: 480px) {
  .news-row {
    padding-top: 10px;
  }

  .news-col {
    margin-bottom: 10px;
  }

  .news-content {
    padding: 10px;
  }
  .top-banner{
    width:100%;
    height:auto;
    margin-top:35px;
    margin-bottom:35px;
    transform: translate(-1%, 5%) scale(3.5); /* 居中并放大 */
  }
}
</style>
